module.exports = __webpack_public_path__ + "static/media/Designers + Artists Meet-Up.00f4149b.png";